import { EOfferSpendByAccountView } from '../../enum'

// Create a union type of all possible values from the enum
type IOfferSpendByAccountViewLangKey = `${EOfferSpendByAccountView}`

export type IOfferSpendByAccountViewLang = {
	offer_spend_by_account_view: Record<IOfferSpendByAccountViewLangKey, string>
}

const langEntries = Object.entries(EOfferSpendByAccountView).map(
	([key, value]) => [value, `offer_spend_by_account_view.${value}`]
)

const langObj: Record<IOfferSpendByAccountViewLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_ACCOUNT_VIEW_LANG_KEY: IOfferSpendByAccountViewLang = {
	offer_spend_by_account_view: langObj
}
